import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Box } from '@elparking/components'
import Feature from './Feature'
import {
    Door,
    Gear,
    Oil,
    Seat,
    Suitcase,
} from '../Icons'
import { defaultFuelTypeFilter, defaultGearBoxFilter } from '../FiltersBox/FiltersBox'

const getName = (type, values) => {
  const items = values.filter(({ value }) => value === type)
  return items.length ? items[0].label : type
}

const CarFeatures = ({
    oilType,
    gear,
    seats,
    doors,
    iconColor,
    suitcase,
    resume,
    intl,
}) => <Box width='100%'>
    {oilType && <Feature icon={<Oil color={iconColor} />} text={getName(oilType, defaultFuelTypeFilter)} />}
    {gear && <Feature icon={<Gear color={iconColor} />} text={getName(gear, defaultGearBoxFilter)} />}
    {seats && <Feature
      icon={<Seat color={iconColor} />}
      text={ resume ? seats : <FormattedMessage defaultMessage='{seats} plazas' values={{ seats }} />}
    />}
    {doors && <Feature icon={<Door
      color={iconColor} />}
      text={ resume ? doors : <FormattedMessage defaultMessage='{doors} puertas' values={{ doors }} />}
    />}
    {suitcase && <Feature icon={<Suitcase color={iconColor} />}
      text={resume ? suitcase : <FormattedMessage defaultMessage='{suitcase} maletas' values={{ suitcase }} />}
    />}
</Box>

CarFeatures.defaultProps = {
    iconColor: 'accent_dark70',
    resume: false,
}

CarFeatures.propTypes = {
    intl: PropTypes.object,
    oilType: PropTypes.string,
    gear: PropTypes.string,
    doors: PropTypes.number,
    seats: PropTypes.number,
    suitcase: PropTypes.number,
    iconColor: PropTypes.string,
    resume: PropTypes.bool,
}

export default CarFeatures
